'use client';

import { motion } from 'framer-motion';
import ScoreGauge from '@/components/tools/ScoreGauge';
import { CheckCircle2 } from 'lucide-react';

const keywords = ['Project Management', 'Agile Methodology', 'SQL & Python', 'Cross-Functional Leadership', 'Data Analysis'];

export default function HeroVisual() {
  return (
    <motion.div
      className="relative flex flex-col items-center"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.3, ease: [0.25, 0.1, 0.25, 1.0] }}
    >
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-6 w-full max-w-sm">
        {/* Mock resume header */}
        <div className="flex items-center gap-3 mb-5 pb-4 border-b border-gray-100">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-blue-600" />
          <div>
            <div className="h-3 bg-gray-800 rounded w-28 mb-1.5" />
            <div className="h-2 bg-gray-300 rounded w-20" />
          </div>
        </div>

        {/* Score gauge */}
        <ScoreGauge score={87} label="ATS Match" size={180} />

        {/* Matched keywords */}
        <div className="mt-5 space-y-2">
          {keywords.map((kw, i) => (
            <motion.div
              key={kw}
              className="flex items-center gap-2.5 text-sm"
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.35, delay: 1.0 + i * 0.1 }}
            >
              <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" />
              <span className="text-gray-700">{kw}</span>
            </motion.div>
          ))}
        </div>

        {/* Status badge */}
        <motion.div
          className="mt-5 text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.6 }}
        >
          <span className="text-xs text-green-600 font-semibold bg-green-50 px-3 py-1.5 rounded-full">
            Ready to submit
          </span>
        </motion.div>
      </div>

      {/* Floating badge */}
      <motion.div
        className="absolute -top-3 -right-3 bg-blue-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, type: 'spring', stiffness: 200 }}
      >
        AI Tailored
      </motion.div>
    </motion.div>
  );
}
